/**
 * Converts a string from snake_case or kebab-case (e.g., 'first_name', 'data-key') to camelCase.
 * It identifies an underscore or hyphen followed by any word character and capitalizes that character.
 */
export const snakeToCamel = (str: string) => (str || '').replace(/([-_]\w)/g, (g) => g[1].toUpperCase());
